import { render, staticRenderFns } from "./TicketActions.vue?vue&type=template&id=0e82bff4&scoped=true"
import script from "./TicketActions.vue?vue&type=script&lang=js"
export * from "./TicketActions.vue?vue&type=script&lang=js"
import style0 from "./TicketActions.vue?vue&type=style&index=0&id=0e82bff4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82bff4",
  null
  
)

export default component.exports